<template>
  <transition name="team-player-selector-fade">
    <div class="team-player-selector-backdrop">
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription"
      >
        <header
          class="team-player-selector-header ml-0 row align-items-center justify-content-md-center"
          id="modalTitle"
        >
          <slot name="header">
            <div class="col-2">
              <button class="menu-button p-0" @click="close"><i class="fas fa-chevron-left"></i></button>
            </div>
            <div class="col-8 text-center">
              Select a player
            </div>
            <div class="col-2"></div>

          </slot>
        </header>
        <section
          class="team-player-selector-body row text-center"
          id="modalDescription"
        >
          <slot name="body">
            <div class="col-6 col-sm-4 col-md-3 col-lg-2 pb-3 team-selector-player-list-player" v-for="player in players"
                 :key="player.id"
                 @click="$emit('selectedTeamPlayer', teamPosition, player.id)">
              <img class="team-selector-player-image mx-auto d-block" :src="player.badgeUrl" crossorigin="anonymous"/>
              {{player.number}} {{player.firstName}} {{player.lastName}}
              <div>{{player.position}}</div>
            </div>
          </slot>
        </section>
        <footer class="team-player-selector-footer text-center">
          <slot name="footer">
            <button
              type="button"
              class="btn primary"
              @click="close"
              aria-label="Close modal"
            >
              Cancel
            </button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>

export default {
  name: 'TeamPlayerSelector',
  props: {
    players: {
      type: Array,
      default () {
        return []
      }
    },
    teamPosition: {
      type: Number,
      default: 0
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
